import request from '../utils/axios'
const base_Url = {
  variables: '/variables',
  inquiryClientInfo: '/inquiry',
}
const Variables = {
  getGlobalVariables: (parmas) =>
    request({
      url: `${base_Url.variables}`,
      method: 'get',
      params: parmas,
    }),
  updateGlobalVariables: (id, data) => {
    const global_variables = [data]
    return request({
      url: `${base_Url.variables}`,
      method: 'put',
      data: {
        global_variables: global_variables,
      },
    })
  },
  clientInfo: (id) => {
    return request({
      url: `${base_Url.inquiryClientInfo}/${id}`,
      method: 'get',
    })
  },
}
export default Variables
